<script setup lang="ts">
import SiteLayout from '@/client/layouts/SiteLayout.vue';
import type { PrivacyContent, SitePageProps } from '@/client/types';
import { Head, Link } from '@inertiajs/vue3';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<
    SitePageProps & {
        privacy: PrivacyContent;
    }
>();

const { t } = useI18n();

const title = computed(() => props.privacy.title || t('site.privacy_policy'));
</script>

<template>
    <Head :title="`${title} — ${brandName}`" />

    <SiteLayout :site="props">
        <article class="mx-auto grid max-w-3xl gap-6 px-4 py-16">
            <Link :href="homeUrl" class="text-sm text-muted-foreground hover:text-foreground">← {{ $t('site.back_home') }}</Link>
            <h1 class="text-3xl font-semibold tracking-tight md:text-4xl">{{ title }}</h1>
            <p v-if="privacy.text" class="leading-relaxed whitespace-pre-line text-muted-foreground">{{ privacy.text }}</p>
        </article>
    </SiteLayout>
</template>
